export const initPromoPhoto = () => {
	document.querySelectorAll( 'section.promo-photo-with-digits-list' ).forEach ( ( promoPhoto) => {
		const img = promoPhoto.querySelector( 'img' );
		const header = document.querySelector( 'header' );
		
		const scrollPromoPhoto = () => {
			const headerHeight = header.offsetHeight;
			const imageHeight = img.offsetHeight;
			const promoPhotoRect = promoPhoto.getBoundingClientRect();
			
			if ( promoPhotoRect.y <= window.innerHeight )
			{
				const maxShift = ( imageHeight - promoPhotoRect.height );
				
				if ( promoPhotoRect.y >= headerHeight - promoPhotoRect.height )
				{
					const fraction = ( ( promoPhotoRect.y + promoPhotoRect.height ) - headerHeight ) / ( ( window.innerHeight + promoPhotoRect.height ) - headerHeight );
					let newShift = fraction * maxShift;
					newShift < 0 ? 0 : newShift;
					
					img.style.top = `${newShift - maxShift}px`;
				}
				else
				{
					img.style.top = `${-1 * maxShift}px`;
				}
			}
			else
			{
				img.style.top = '0px';
			}
		};
		
		const initPhotoScroll = () => {
			window.addEventListener( 'scroll', scrollPromoPhoto );
			window.addEventListener( 'resize', scrollPromoPhoto );
			
			scrollPromoPhoto();
			
			// Тег изображения может быть загружен, но изображение недоступно
			if ( img.naturalWidth === 0 || img.naturalHeight === 0 )
			{
				img.removeEventListener( 'load', scrollPromoPhoto );
				img.addEventListener( 'load', scrollPromoPhoto );
			}
		};
		
		if ( img )
		{
			if ( img.complete )
			{
				initPhotoScroll();
			}
			else
			{
				img.addEventListener( 'load', initPhotoScroll );
			}
		}
	} );
};
